import { configureStore } from "@reduxjs/toolkit";
import { openReplayReduxMiddleware } from "tools/open-replay";
import rootReducer from "./rootReducer";
import { setRegisteredStore } from "./store-registry";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(openReplayReduxMiddleware),
});
setRegisteredStore(store);
export default store;
